const roleInfo = {
  // 游戏充值档位
  PayGrade: `/payApi/v1/RoleInfo/GamePayGrade`,
  // 充值账号校验
  CheckUser: `/payApi/v1/RoleInfo/CheckUser`,
  // 游戏选择
  UserGames: `/payApi/v1/RoleInfo/UserGames`,
  // 玩家区服
  ServerList: `/payApi/v1/RoleInfo/ServerList`,
  // 选择角色
  RoleList: `/payApi/v1/RoleInfo/RoleList`,
  // 盒子充值档位
  BoxPayGrade: `/payApi/v1/RoleInfo/BoxPayGrade`,
  // 盒子充值币种
  getPayInfo: `/payApi/v1/RoleInfo/GamePayItem`,
  // 游戏是否关闭盒币充值
  gameSupportBalRecharge: `/payApi/v1/RoleInfo/gameSupportBalRecharge`
};

export default roleInfo;
